<template>
  <product
    :product-logo="productLogo"
    :product-brief="productBrief"
    :carousel-items-no="1"
    :carousel-images="carouselImages"
  >
    <p>
      The client is one of the top real estate agents in Ukraine.
      Eventually, he wanted to bring more order into the business
      processes and build a CRM for their agency. This resulted in a
      complex system with a lot of domain-specific features.
    </p>
    <p>
      My part was the API for a web-app. Specifically:
      <ul>
        <li>
          Users login/registration/approval.
        </li>
        <li>
          Properties and Buyers listings.
        </li>
        <li>
          Roles restrictions from guests, agents/managers, admins, based
          on role and level of ownership of particular property/buyer.
        </li>
        <li>
          Detailed filtering for Buyers and Properties.
        </li>
        <li>
          Centralized contacts(clients) base, that is tied to all the
          listings in a system.
        </li>
        <li>
          Keeping track of all the activity for any property/buyer.
        </li>
        <li>
          Smart relation system that features all the properties/buyers,
          associated with a particular person.
        </li>
      </ul>
    </p>
    <p>
      Right now - the app is in production and is constantly improved.
      Also, we noticed a potential in turning a platform into
      SaaS-product, and providing it to other real estate agencies. This
      option is under discussion at the moment. Meanwhile, according to
      the client, this CRM had already made them 40% more effective.
    </p>

    <template v-slot:footer>
      <div class="col-12 mt-3 py-2 next-btn next-btn__cta">
        <router-link :to="{ name: 'GetInTouch' }" class="py-2">
          <span
            >Seen enough? Contact Me to discuss your next big product!</span
          >
          <font-awesome-icon icon="plus-square" size="2x" />
        </router-link>
      </div>
    </template>
  </product>
</template>

<script>
import Product from '@/components/product/Product'
export default {
  components: { Product },
  data() {
    return {
      productLogo: require('@/assets/img/products/HaldenEstate.png'),
      productBrief: 'Real Estate CRM for Halden.estate',
      carouselImages: [
        require('@/assets/img/products/hldn/1.png'),
        require('@/assets/img/products/hldn/2.png'),
        require('@/assets/img/products/hldn/4.png'),
        require('@/assets/img/products/hldn/3.png'),
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
section.main {
  background-image: linear-gradient(#738edf4a, #4c556e4e),
    url("~@/assets/img/products/hldn/cover.jpg");
  background-image: linear-gradient(#738edf4a, #4c556e4e), url(/img/cover.0e196e18.jpg);
  background-position: center top;
}
</style>
